import { Card, Space, Typography } from 'antd';

import { Icon } from '@/shared/ui/Icon';

const { Title, Paragraph } = Typography;

type ComingSoonProps = {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export const ComingSoon: React.FC<ComingSoonProps> = ({
  title,
  description,
  icon = <Icon name="clock" style={{ marginRight: '8px' }} />,
  className,
  style,
}) => {
  return (
    <div style={{ padding: '24px', ...style }} className={className}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Title level={2}>
            {icon}
            {title}
          </Title>
          {description && <Paragraph type="secondary">{description}</Paragraph>}
        </div>

        <Card>
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Icon name="clock" size={48} color="#d9d9d9" />
            <Title level={4} style={{ marginTop: '16px', color: '#999' }}>
              곧 제공될 예정입니다
            </Title>
            <Paragraph type="secondary">이 기능은 현재 개발 중이며, 곧 사용하실 수 있습니다.</Paragraph>
          </div>
        </Card>
      </Space>
    </div>
  );
};
